<template>
  <div class="profile">

      <!-- INIT Resume Panel-->
      <b-row>
        <b-col>
          <user-profile></user-profile>
        </b-col>
      </b-row>


  </div>
</template>

<script>
import Userprofile from '@/components/users/Profile';

export default {
    data () {
        return {

        }
    },
    components: {
      'user-profile': Userprofile
    }
}
</script>
